// @flow
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { useNavigate } from 'react-router';
import Copyrights from '../../common/components/Copyrights';
import AppLogo from '../../common/components/AppLogo';

const PublicPage = ({ children, withLogo }: any): React$Node => {
  const navigate = useNavigate();
  return (
    <Container component="main" maxWidth="xs">
      {withLogo && <AppLogo onClick={() => navigate('/')} />}
      <Box
        sx={{
          marginTop: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        {children}
      </Box>
      {withLogo && <Copyrights />}
    </Container>
  );
};

export default PublicPage;
